import grid from './grid';
import mediaQueries from '../helpers/mediaQueries';

export default {
  grid: grid,
  media: mediaQueries(grid.breakpoints)
};
